'use client';

import Link from 'next/link';

interface LogoBrandProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const config = {
  xs: { fontSize: 18, letterSpacing: '-0.02em' },
  sm: { fontSize: 22, letterSpacing: '-0.02em' },
  md: { fontSize: 28, letterSpacing: '-0.02em' },
  lg: { fontSize: 36, letterSpacing: '-0.02em' },
};

export default function LogoBrand({ size = 'md', className = '' }: LogoBrandProps) {
  const c = config[size];

  return (
    <Link
      href="/"
      style={{ display: 'inline-flex', textDecoration: 'none' }}
      aria-label="Pro IT Solutions — Home"
      className={className}
    >
      <span
        style={{
          fontFamily: "'Syne', sans-serif",
          fontWeight: 800,
          fontSize: `${c.fontSize}px`,
          letterSpacing: c.letterSpacing,
          wordSpacing: '-0.15em',
          background: 'linear-gradient(135deg, #0057FF 0%, #00C8FF 45%, #00E5A0 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Pro IT Solutions
      </span>
    </Link>
  );
}
